export const EMPTY_STATE_IMAGES = {
  signUpbanner: 'https://res.cloudinary.com/samvibes/image/upload/signup-banner.png',
  learnerImage:
    'https://cms.staging.sketchnote.co/uploads/empty_state_lessons_in_progress_ecd307b9cd.png',
};

export const Lesson_Card_IMAGES = {
  lessonImage:
    'https://res.cloudinary.com/samvibes/image/upload/v1639573576/banners/gallery/paintings/Landscape%20paintings/The_Advance-Guard_or_The_Military_Sacrifice_The_Ambush_1890_Frederic_Remington.jpg',
};

export const LmsDashboardConstant = {
  lmsLable: 'LMS',
  createWorkspace: 'Create workspace',
  createWorkspaceInfo: 'Create and complete courses or programs associated with your school',
  learnerInfo: 'Complete courses assigned to you or associated with your organization',
  instructorInfo: 'Create and assign courses to your organization or Sketchnote users',
  reminder: 'Reminder',
  reminderInfo: 'Tasks that require your immediate attention',
  due: 'Due:',
  getStarted: 'Get started',
  lessonDueLable: 'Lessons due soon',
  courseName: 'Course Name',
  workspaceLable: 'Workspace',
  instructorLable: 'Instructor',
  learnerLable: 'Learner',
  progressLable: 'Progress',
  deadlineLable: 'Deadline',
  inProgressLable: 'In progress',
  inProgressLessonsLable: 'In Progress Lessons',
  viewAll: 'View All',
  continueLearning: 'Continue learning',
  startLearning: 'Start learning',
  importSnLesson: 'Import',
  allCourseLable: 'All Courses',
  whatInsideLable: `What's Inside`,
  whatYouLearnLable: `What you'll learn`,
  allLessonsLable: 'All your lessons',
  publishedLessonsLable: 'Published lessons',
  unpublishedLessonsLable: 'Unpublished lessons',
  searchLesson: 'Search for a lesson...',
  addNewWorkspaceBtn: 'Add new workspace',
  viewLmsDashboard: 'View LMS dashboard',
  sidebarCreateWorkspaceInfo: 'Create workspaces for different teams or projects',
  chooseImage: 'Choose image',
  changeCover: 'Change cover',
  uploadImgInstruction: 'Images wider than 1500 pixels work best',
  recentUploads: 'Recent uploads',
  embedImage: 'Embed image',
  remove: 'Remove',
  addCover: 'Add cover',
  createdBy: 'Created by',
  copyLink: 'Copy link',
  lessonHasDeadlineText: '⏳This lesson has a deadline',
  setADeadline: 'Set a deadline',
  ifTheDeadlinePasses: 'If the deadline passes:',
  deletingTheWorkspace: 'Deleting the workspace',
  workspaceDeleteInfo: `You are about to delete a workspace with published lessons. All lessons will be unpublished and user's learning data will be lost permanently.`,
  workspaceDeleteConfirmation: 'Are you sure you want to go ahead?',
  cancel: 'Cancel',
  delete: 'Yes, delete',
  quiz: 'quiz',
  flashcard: 'flashcard',
  untitled: 'Untitled',
  cards: 'cards',
  unPublishedWarning:
    'This lesson is temporarily inaccessible. All your progress will be intact. Please contact the instructor for further details.',
  coverFill: 'Cover Fill',
  coverFit: 'Cover Fit',
};
